import { defineStore } from 'pinia'

export const useWorkspaceStore = defineStore('workspace', {
  state: () => ({
    user: 'user_123',
    extension: '3015',
    call: false,
    number: '',
    lastNumber: null as string | null,
    contactos: [] as { name: string; phone: string }[],
    webphoneCallStatus: 'idle' as 'idle' | 'calling' | 'incoming' | 'connected' | 'held',
    showEzdial: false,
    showNotes: false,
    showNotesCall: false,
    showVideoCall: false,
    showDialogImportContactEZdial: false,
  }),
  getters: {
    isOnCall(state): boolean {
      return state.call
    },
    getLastNumber(state): string | null {
      return state.lastNumber
    },
    getContactos(state): { name: string; phone: string }[] {
      return state.contactos
    },
    isEzdialVisible(state): boolean {
      return state.showEzdial
    },
    isNotesVisible(state): boolean {
      return state.showNotes
    },
    isVideoCallVisible(state): boolean {
      return state.showVideoCall
    },
    isNotesCallVisible(state): boolean {
      return state.showNotesCall
    },
    isDialogImportContactEZdialVisible(state): boolean {
      return state.showDialogImportContactEZdial
    },
  },
  actions: {
    setCallStatus(status: boolean) {
      this.call = status
    },
    setLastNumber(number: string) {
      this.lastNumber = number
    },
    setCurrentNumber(number: string) {
      const normalizedNumber = number.trim()
      this.number = normalizedNumber
      if (normalizedNumber) {
        this.lastNumber = normalizedNumber
      }
    },
    addContacto(contacto: { name: string; phone: string }) {
      this.contactos.push(contacto)
    },
    toggleEzdial() {
      this.showEzdial = !this.showEzdial
    },
    toggleNotes() {
      this.showNotes = !this.showNotes
    },
    toggleVideoCall() {
      this.showVideoCall = !this.showVideoCall
    },
    toggleNotesCall() {
      this.showNotesCall = !this.showNotesCall
    },
    toggleDialogImportContactEZdial() {
      this.showDialogImportContactEZdial = !this.showDialogImportContactEZdial
    }
  },

})

